import { ClearFilters, SortSelector, StatusFilter } from '#src/app/pages/searchV2/shared/components';

import { AllFiltersMobileButton } from './components/AllFiltersMobileButton';
import { LocationMobileButton } from './components/LocationMobileButton';
import { TopicsMobileButton } from './components/TopicsMobileButton';
import { TotalResultsText } from './components/TotalResultsText';
import { useMobileFilters } from './hooks/useMobileFilters';

export const MobileFilters: React.FC = () => {
	const {
		data: { isLoading },
	} = useMobileFilters();

	if (isLoading) {
		return null;
	}

	return (
		<div className="mt-4 block md:hidden">
			<div className="container flex items-center justify-between">
				<AllFiltersMobileButton />
				<TotalResultsText />
			</div>

			<div className="mt-4 mb-4 flex gap-4 overflow-x-auto px-4 whitespace-nowrap">
				<LocationMobileButton />
				<TopicsMobileButton />
				<StatusFilter desktopView={false} />
				<SortSelector desktopView={false} />
				<ClearFilters />
			</div>
		</div>
	);
};
